__turbopack_context__.v({
  "hero-body": "I4LCrq_hero-body",
  "hero-image": "I4LCrq_hero-image",
  "hero-media": "I4LCrq_hero-media",
  "hero-title": "I4LCrq_hero-title",
  "institutions": "I4LCrq_institutions",
  "institutions-copy": "I4LCrq_institutions-copy",
  "institutions-image": "I4LCrq_institutions-image",
  "institutions-media": "I4LCrq_institutions-media",
  "institutions-title": "I4LCrq_institutions-title",
  "intro": "I4LCrq_intro",
  "lead": "I4LCrq_lead",
  "partner-card": "I4LCrq_partner-card",
  "partner-logo": "I4LCrq_partner-logo",
  "partner-logo-image": "I4LCrq_partner-logo-image",
  "partner-name": "I4LCrq_partner-name",
  "partners-title": "I4LCrq_partners-title",
  "title": "I4LCrq_title",
});
